// This code manages the sticky footer add to cart section on mobile
(() => {

  
    const form = document.querySelector('.product-block > form');
	if(!form) return;
    const variantSelector = form.querySelector('[name="id"]');
    const variants = JSON.parse(document.querySelector('textarea[data-variant-json]').value);

    const isDisabled = (variantId) => {
      return !variants.find(({ id }) => id === variantId)?.available;
    }

    if (!variantSelector) {
        return;
    }

    const starRating = document.querySelector('.loox-rating').cloneNode(true);

    const availabilityIndicator = document.createElement('div');
    availabilityIndicator.classList.add('availability-indicator');
    const title = document.createElement('div');
    title.classList.add('title');
    const variantSelectorClone = variantSelector.cloneNode(true)
    variantSelectorClone.setAttribute('name', 'id-clone');
    variantSelectorClone.classList.add('mobile-footer-variant-selector');
    variantSelectorClone.querySelectorAll('option').forEach(option => {
      if (isDisabled(parseInt(option.value))) {
        option.disabled = true
      }
    })


    syncOptionsWithSelect = (e) => {
      const selector = e.target;
      const variantId = parseInt(selector.value);
      const variant = variants.find(({ id }) => id === variantId);
      const variantWrappers = Array.from(document.querySelectorAll('.product-block > .variant-wrapper'));
      variant.options.forEach((option, index) => {
        const wrapper = variantWrappers[index];
        const radioItem = wrapper.querySelector('input[type="radio"][value="'+option+'"]');
        radioItem.checked = true
      })
    }

    variantSelectorClone.addEventListener('change', (e) => {
      setTimeout(() => {
        variantSelector.selectedIndex = e.target.selectedIndex
        syncOptionsWithSelect(e)
      }, 0)
    })

    variantSelector.addEventListener('change', (e) => {
      setTimeout(() => {
        variantSelectorClone.selectedIndex = e.target.selectedIndex
      }, 0)
    })


  
    const leftHalf = document.createElement('div');
    leftHalf.classList.add('atc-left-block');
    leftHalf.append(availabilityIndicator);
    leftHalf.append(starRating);
   // leftHalf.append(title);
    

    const salePrice = document.createElement('div');
    const compareAtPrice = document.createElement('div');
    const rightHalf = document.createElement('div');

    rightHalf.classList.add('atc-right-block');
    salePrice.classList.add('sale-price');
    compareAtPrice.classList.add('compare-at-price', 'product__price--compare');

    rightHalf.append(salePrice);
    rightHalf.append(compareAtPrice);

    const button = form.querySelector('button[name="add"]').cloneNode(true);
    button.removeAttribute('type');

    button.addEventListener('click', () => {
        form.querySelector('button[name="add"]').click();
    });

    const footer = document.createElement('div');
    footer.setAttribute('id', 'sticky-footer-add-to-cart');
    footer.style.display = 'none'; // Initially hidden

    const existing = document.querySelector('#sticky-footer-add-to-cart');
    if (existing) {
        document.body.removeChild(existing);
    }

    footer.append(leftHalf);
    footer.append(rightHalf);
    footer.append(variantSelectorClone);
    footer.append(button);
    document.body.append(footer);

    const updateVariant = (e) => {
        const variantId = e.detail.variant.id;
        const variant = variants.find(({ id }) => id === variantId);
      
        if (variant) {
            if (!variant.available) {
                availabilityIndicator.classList.add('not-available');
                button.setAttribute('disabled', true)
                button.classList.add('disabled');
                button.innerText = 'Sold Out';
            } else {
                availabilityIndicator.classList.remove('not-available');
                button.removeAttribute('disabled');
                button.classList.remove('disabled');
                button.innerText = 'Add to cart';
            }
            salePrice.innerText = document.querySelector('div.product-section [data-product-blocks] span[data-product-price]').innerText;
            if (variant.compare_at_price > variant.price) {
                compareAtPrice.innerText = document.querySelector('div.product-section [data-product-blocks] span[data-compare-price]').innerText;
            } else {
                compareAtPrice.innerText = '';
            }
            title.innerText = variant.name;
        }
    };

    // variantSelector.addEventListener('change', updateVariant);
    document.addEventListener('variant:change', updateVariant)

    const checkFooterVisibility = () => {
        const windowWidth = window.innerWidth;
        const submitButton = document.querySelector('.product-block form button[type="submit"]');
        if (!submitButton) return;

        const thresholdHeight = 300; // Set your desired threshold height
        const buttonRect = submitButton.getBoundingClientRect();
        if (windowWidth < 590 && buttonRect.bottom < thresholdHeight) {
            footer.style.display = 'flex';
            footer.classList.add('atc-visible');
        } else {
         // footer.style.display = 'none';
          footer.classList.remove('atc-visible');
        }
    };

    window.addEventListener('resize', checkFooterVisibility);
    window.addEventListener('scroll', checkFooterVisibility);

    setTimeout(() => {
      updateVariant({detail: {variant: { id: parseInt(loomi_ctx.variantId)}}});
    }, 1000)
    
    checkFooterVisibility();

})();